// Tiny Redux slice that remembers which organisation the user is "viewing".
// When `id` is set, the app is in org-level view (Dashboard + Subscription only).

export const ORG_CONTEXT_SET = 'ORG_CONTEXT_SET';
export const ORG_CONTEXT_CLEAR = 'ORG_CONTEXT_CLEAR';

export const orgContextActions = {
  setOrgContext: ({ id, name }) => ({
    type: ORG_CONTEXT_SET,
    payload: { id, name }
  }),
  clearOrgContext: () => ({
    type: ORG_CONTEXT_CLEAR
  })
};

const initialState = {
  id: null,
  name: null
};

export function orgContext(state = initialState, action) {
  switch (action.type) {
    case ORG_CONTEXT_SET:
      return { id: action.payload.id, name: action.payload.name };
    case ORG_CONTEXT_CLEAR:
      return { ...initialState };
    default:
      return state;
  }
}
